export const clamp = (number, lower, upper) => {
	if (number < lower) {
		return lower;
	} else if (number > upper) {
		return upper;
	} else {
		return number;
	}
};

export const forOwn = (obj, callback) => {
	for (const key in obj) {
		if (Object.prototype.hasOwnProperty.call(obj, key)) {
			callback(obj[key], key);
		}
	}
};

export const keyBy = <T>(array: Array<T>, key: string) => {
	return array.reduce<Record<string, T>>((acc, obj) => {
		acc[obj[key]] = obj;
		return acc;
	}, {});
};

export const last = (array) => {
	if (!Array.isArray(array) || array.length === 0) {
		return undefined; // Si no es un array o está vacío, devolver undefined
	}
	return array[array.length - 1]; // Devolver el último elemento del array
};

export const fill = (array, value, start = 0, end = array.length) => {
	// Validar los índices de inicio y fin
	start = start < 0 ? Math.max(array.length + start, 0) : Math.min(start, array.length);
	end = end < 0 ? Math.max(array.length + end, 0) : Math.min(end, array.length);

	// Llenar el array con el valor especificado
	for (let i = start; i < end; i++) {
		array[i] = value;
	}

	return array;
};

export const includes = (collection, value) => {
	if (Array.isArray(collection)) {
		return collection.includes(value);
	}
	if (typeof collection === 'string') {
		return collection.includes(value);
	}
	if (collection instanceof Set) {
		return collection.has(value);
	}
	if (typeof collection === 'object' && collection !== null) {
		return Object.values(collection).includes(value);
	}
	return false;
};

export const forEach = (collection, iteratee) => {
	if (Array.isArray(collection)) {
		collection.forEach((value, index) => iteratee(value, index, collection));
	} else if (typeof collection === 'object' && collection !== null) {
		Object.keys(collection).forEach((key) => {
			iteratee(collection[key], key, collection);
		});
	}
};

export const minBy = (array, iteratee) => {
	if (!Array.isArray(array) || array.length === 0) {
		return undefined;
	}

	return array.reduce((min, current) => {
		const currentValue = typeof iteratee === 'function' ? iteratee(current) : current[iteratee];
		const minValue = typeof iteratee === 'function' ? iteratee(min) : min[iteratee];

		return currentValue < minValue ? current : min;
	}, array[0]);
};

export const fromPairs = (pairs) => {
	return pairs.reduce((acc, pair) => {
		acc[pair[0]] = pair[1];
		return acc;
	}, {});
};
